<header id="app-header">
    <div class="logo-container row flex-center" id="login">
        <img src="assets/images/logo-krematorium-am-limes.png" alt="Krematorium am Limes" draggable="false" class="container">
    </div>
</header>

<main id="main" class="container" style="margin-top: 50px;">
    <div class="row main-content-row">
        <div class="col s12">
            <div class="container login-container">
                <div class="column start">
                    <form class="login-form" (ngSubmit)="loginButtonClicked()">
                        <h1 class="redesign" style="margin-bottom: 50px;">Bestatter-Login</h1>

                        <div class="row" style="margin-bottom: 20px">
                            <input id="loginUsername" name="loginUsername" type="text" class="login-input redesign"
                                placeholder="Benutzername" [(ngModel)]="loginUsername" />
                        </div>

                        <div class="row">
                            <input id="loginPassword" name="loginPassword" type="password" class="login-input redesign"
                                placeholder="Passwort" [(ngModel)]="loginPassword" (keyup.enter)="loginButtonClicked()"
                                style="margin-right: 72dp;" />
                        </div>


                        <div class="redesign action tooltipped right" style="margin-top: -16px;"
                            (click)="togglePasswordVisibility()">
                            Passwort <span *ngIf="!isPasswordVisible">anzeigen</span><span
                                *ngIf="isPasswordVisible">ausblenden</span>
                        </div>

                        <div class="login-button" style="margin-top: 50px;margin-bottom: 100px;" *ngIf="isApplicationOnline">
                            <h1 class="redesign action prefixed" (click)="loginButtonClicked()" style="margin:0">
                                <span *ngIf="!isLoading">Einloggen</span>
                                <span *ngIf="isLoading" class="loading-spinner"></span>
                            </h1>
                        </div>
                        <div class="login-button" style="margin-top: 50px;margin-bottom: 100px;" *ngIf="!isApplicationOnline">
                            <h1 class="redesign action prefixed" (click)="loginButtonClicked()" style="margin:0">
                                Offline</h1>
                        </div>

                        <div class="kremasoft-branding hide-on-small-only">
                            <p class="redesign" style="margin-bottom: 10px; text-align: right;">betrieben mit</p>
                            <div style="text-align: right;">
                                <a href="https://www.kremasoft.de" target="_blank" rel="noopener noreferrer" style="display: inline-block;">
                                    <img src="assets/images/kremasoft-logo.png" 
                                         alt="KremaSoft" 
                                         style="max-height: 40px; width: auto;">
                                </a>
                            </div>
                        </div>

                        <div class="password-help-section">
                            <h3 class="redesign password-help-text">
                                Passwort vergessen? Sprechen Sie uns an per E-Mail
                                <a href="mailto:info&#64;krematorium-am-limes.de">info&#64;krematorium-am-limes.de</a>
                                <span class="desktop-comma">,</span>
                                <span class="mobile-break"><br></span>
                                per Telefon
                                <a href="tel:06291647970">06291 - 647970</a>,
                                <span class="desktop-text">oder fordern Sie es sofort&nbsp;</span>
                                <span class="mobile-text"><br>oder fordern Sie es sofort&nbsp;</span>
                                <a onclick="openContactModal()" style="text-decoration: underline" class="cursor-pointer action">online</a>
                                &nbsp;neu an.
                            </h3>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</main>

<div id="change-password-modal" class="modal password-modal">
    <div class="modal-content">
        <h4>Passwort &auml;ndern</h4>
        <p>Aus Sicherheitsgr&uuml;nden muss ihr Passwort vor der n&auml;chsten Anmeldung einmalig ge&auml;ndert werden.
            Das Passwort muss aus mindestens acht
            Zeichen bestehen,
            mindestens einen Großbuchstaben, mindestens eine Zahl und mindestens ein Sonderzeichen enthalten.</p>
        <form (ngSubmit)="changePasswordButtonClicked()">
            <div class="center">
                <div class="row">
                    <div class="input-field col s12">
                        <input id="newPassword" name="newPassword" type="password" class="validate"
                            [(ngModel)]="newPassword">
                        <label for="newPassword">Neues Passwort</label>
                    </div>
                    <div class="input-field col s12">
                        <input id="confirmPassword" name="confirmPassword" type="password" class="validate"
                            [(ngModel)]="confirmPassword">
                        <label for="confirmPassword">Passwort Best&auml;tigung</label>
                    </div>
                </div>
                <div class="row right-align">
                    <div class="input-field col s12">
                        <input type="submit" class="waves-effect waves-light btn juvo-color white-text"
                            value="Speichern">
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>